
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streams/[id]/[slug]",
      function () {
        return require("private-next-pages/streams/[id]/[slug].tsx");
      }
    ]);
  